export const getImageUrl = (imageName: string) => {
  return `https://www.hungrystudio.com/file/${imageName}`;
};
